import { render } from "./ClassesList.vue?vue&type=template&id=35f024da"
import script from "./ClassesList.vue?vue&type=script&lang=js"
export * from "./ClassesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__